var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBuildings = function SvgIconBuildings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.875 16.5a1 1 0 0 1 1-1h.75a1 1 0 1 1 0 2h-.75a1 1 0 0 1-1-1M16.875 11.75a1 1 0 1 0 0 2h.75a1 1 0 1 0 0-2zM6.375 5.75a1 1 0 0 0 0 2H9a1 1 0 0 0 0-2zM6.5 12.75a1 1 0 0 1 1-1h2.625a1 1 0 1 1 0 2H7.5a1 1 0 0 1-1-1M6.375 15.5a1 1 0 1 0 0 2H9a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 2A1.75 1.75 0 0 0 2 3.75v15.5h-.5a1 1 0 1 0 0 2h21a1 1 0 1 0 0-2H22v-9.5A1.75 1.75 0 0 0 20.25 8H14.5V3.75A1.75 1.75 0 0 0 12.75 2zM20 10v9.25h-5.5V10zm-7.5-6v15.25H4V4z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBuildings;